import { render, staticRenderFns } from "./LangTags.vue?vue&type=template&id=29e7005a&scoped=true&"
import script from "./LangTags.vue?vue&type=script&lang=js&"
export * from "./LangTags.vue?vue&type=script&lang=js&"
import style0 from "./LangTags.vue?vue&type=style&index=0&id=29e7005a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e7005a",
  null
  
)

export default component.exports